import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Set the browser tab title, meta description, and canonical URL for the
 * current page. Works with the SPA, updates on every route change.
 *
 * Usage:
 *   usePageMeta({
 *     title: "About Navica Supports",
 *     description: "AASW-accredited social work and NDIS Support Coordination in Sydney.",
 *   });
 */
export default function usePageMeta({ title, description, canonical }) {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title.includes("Navica")
        ? title
        : `${title}, Navica Supports`;
    }

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }

    if (title) {
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }

    const url = `https://navicasupports.com${location.pathname}`;
    setLink("canonical", canonical || url);
    setMeta("property", "og:url", canonical || url);
  }, [title, description, canonical, location.pathname]);
}

function setMeta(keyAttr, keyValue, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${keyAttr}="${keyValue}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(keyAttr, keyValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}
